'use strict';

(function (angular) {
    'use strict';

    angular.module('zp.nav').controller('navController', navController);

    /** @ngInject */
    function navController($rootScope, $window, $state, $uibModal, authService, vendorsService, SearchService) {

        var vm = this;

        vm.vendors = [[], [], []];
        vm.showVendors = false;
        vm.searchModel = null;
        vm.sidenavStyle = { width: '0px' };

        // public functions references/properties
        vm.openLoginModal = openLoginModal;
        vm.logout = logout;
        vm.selectVendor = selectVendor;
        vm.sanitizeVendor = sanitizeVendor;
        vm.toggleVendors = toggleVendors;
        vm.openSidenav = openSidenav;
        vm.closeSidenav = closeSidenav;

        // private variables/properties

        (function activate() {
            loadVendors().then(loadSearchModel);

            $rootScope.$on('OPEN_SIDE_MENU', function () {
                if ($window.innerWidth < 769) {
                    openSidenav();
                }
            });

            $rootScope.$on('CLOSE_SIDE_MENU', function () {
                if ($window.innerWidth < 769) {
                    closeSidenav();
                }
            });
        })();

        function openLoginModal() {
            $uibModal.open({
                animation: true,
                templateUrl: 'app/auth/auth.login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                resolve: {
                    options: function options() {
                        return {};
                    }
                }
            });
        }

        function logout() {
            return authService.logout();
        }

        function loadVendors() {
            return vendorsService.getAll().then(function (res) {
                for (var i = 0; i < res.length; i++) {
                    if (i < 9) {
                        vm.vendors[0].push(res[i]);
                        continue;
                    } else if (i < 18) {
                        vm.vendors[1].push(res[i]);
                    } else {
                        vm.vendors[2].push(res[i]);
                    }
                }
            });
        }

        function loadSearchModel() {
            return SearchService.getSearchModel().then(function (s) {
                vm.searchModel = s;
            });
        }

        function selectVendor(vendor) {
            vm.searchModel.selectedCategory = vendor;
            $state.go('nav.results', { vendor: vendor });
        }

        function sanitizeVendor(vendor) {
            return vendor.replace(/ /g, '-').toLowerCase();
        }

        function toggleVendors() {
            vm.showVendors = !vm.showVendors;
        }

        function openSidenav() {
            vm.sidenavStyle.width = '250px';
        }

        function closeSidenav() {
            vm.sidenavStyle.width = '0px';
        }
    }
})(window.angular);